var _path, _g, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicalTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3644_32088",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.13745H27V29.0001H5V2.13745Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3644_32088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5002C26.1039 19.8578 19.8211 25.1002 17.2281 27.09C16.5682 27.5963 15.6727 27.6017 15.0068 27.1034C12.3613 25.1238 5.89704 19.8676 5.5 15.5002C5.5 9.82717 9.83422 2.00024 16.1223 2.00024C22.4103 2.00024 26.5 9.82717 26.5 15.5002Z",
    fill: "#08437A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#08437A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#08437A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0818 17.5C13.9005 17.5 13.7382 17.4484 13.595 17.3453C13.4518 17.2422 13.3468 17.1109 13.28 16.9516L11.9627 13.5625H9.5V12.4375H12.7645L14.0818 15.8687L16.7164 9.04844C16.7832 8.88906 16.8882 8.75781 17.0314 8.65469C17.1745 8.55156 17.3368 8.5 17.5182 8.5C17.6995 8.5 17.8618 8.55156 18.005 8.65469C18.1482 8.75781 18.2532 8.88906 18.32 9.04844L19.6373 12.4375H22.1V13.5625H18.8355L17.5182 10.1312L14.8836 16.9516C14.8168 17.1109 14.7118 17.2422 14.5686 17.3453C14.4255 17.4484 14.2632 17.5 14.0818 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalTrial);
export default __webpack_public_path__ + "static/media/clinical_trial.b14f64772979e5396df6bb0e55023bd6.svg";
export { ForwardRef as ReactComponent };